// eslint-disable-next-line no-restricted-imports
import { MessageSeverityEnum } from '@eih-netbroker/api-notification';

export const MessageSeverity = MessageSeverityEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type MessageSeverity = (typeof MessageSeverity)[keyof typeof MessageSeverity];
